<script setup lang="ts">
type GapSize = 0 | 1 | 2 | 3 | 4 | 5 | 6;

type Props = {
  gap?: GapSize;
  fluid?: boolean;
  grow?: boolean,
}

const props = withDefaults(defineProps<Props>(), {
  gap: 6,
  fluid: true,
  grow: false,
});
</script>
<template>
  <div
    class="flex flex-col"
    :class="{
      'gap-0': Number(props.gap) === 0,
      'gap-1': Number(props.gap) === 1,
      'gap-2': Number(props.gap) === 2,
      'gap-3': Number(props.gap) === 3,
      'gap-4': Number(props.gap) === 4,
      'gap-5': Number(props.gap) === 5,
      'gap-6': Number(props.gap) === 6,
      'w-full': props.fluid,
      'grow': props.grow
    }"
  >
    <slot />
  </div>
</template>
